import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import { BACK_END_URL } from '@/utilities/config';

export const useAnalyticsStore = defineStore("useAnalyticsStore", () => {
  const generalData = ref({}); // General analytics data
  const movementData = ref({}); // Movement-specific data
  const voters = ref([]); // Voter data
  const provinceData = ref(null);

  // Fetch general analytics data
  const fetchData = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) return console.error("No token found.");
  
    // Otherwise, make the API call to fetch data
    try {
      const response = await axios.get(`${BACK_END_URL}/analytics/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      generalData.value = response.data.estados; // Store data in Vue state
      return generalData.value; // Retorna los datos obtenidos

    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
  };
  

  const fetchMovementData = async (provinceId) => {    
    const token = sessionStorage.getItem("token");
    if (!token) return console.error("No token found.");
  
    try {
      if (provinceId) {
        const response = await axios.get(`${BACK_END_URL}/analytics/dashboard?provincia=${provinceId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        movementData.value = response.data.movimientos[provinceId]; // Store data in Vue state
    
      } else {
        const response = await axios.get(`${BACK_END_URL}/analytics/dashboard`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        movementData.value = response.data;   
      }
    
    } catch (error) {
      console.error("Error fetching movement data:", error);
    }
  };
  


  // Function to get data for a specific province (if provided)
  const fetchProvinceData = (provinceId) => {
    if (!generalData.value) {
      console.error("General data is not loaded yet.");
      return;
    }
    
    provinceData.value = generalData.value[provinceId] || null;
  };

  const fetchVoters = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) return console.error("No token found.");

    try {
      const response = await axios.get(`${BACK_END_URL}/analytics/voters`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      voters.value = response.data;
    } catch (error) {
      console.error("Error fetching voters data:", error);
    }
  };

  return { 
    generalData, 
    movementData, 
    voters, 
    provinceData, 
    fetchData, 
    fetchMovementData, 
    fetchVoters, 
    fetchProvinceData 
  };
});
